import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../backend/firebase';
import { recordReadWriteCount } from '../utils/withReadCounter';

export interface LiveProfile {
  uid: string;
  displayName?: string;
  username?: string;
  email?: string;
  phone?: string;
  photoURL?: string;
  bio?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  followerCount?: number;
  fansCount?: number;
  followingCount?: number;
  role?: string;
  [key: string]: unknown;
}

export function useLiveProfile(uid: string | undefined, isSelf: boolean) {
  const [profile, setProfile] = useState<LiveProfile | null>(null);
  const [loading, setLoading] = useState(Boolean(uid));
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setProfile(null);
    setError(null);
    if (!uid) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const profileRef = doc(db, isSelf ? 'users' : 'publicProfiles', uid);
    return onSnapshot(profileRef, snapshot => {
      recordReadWriteCount('profile', { reads: snapshot.metadata.fromCache ? 0 : 1 });
      setProfile(snapshot.exists()
        ? { uid: snapshot.id, ...snapshot.data() } as LiveProfile
        : null);
      setError(null);
      setLoading(false);
    }, snapshotError => {
      setError(snapshotError);
      setLoading(false);
    });
  }, [uid, isSelf]);

  return { profile, loading, error };
}
